/**
 * Recursively transforms all object keys from snake_case to camelCase.
 *
 * - Arrays: each element is transformed recursively.
 * - Objects: each key is converted; values are transformed recursively.
 * - Primitives (string, number, boolean, null): returned as-is.
 *
 * Intended for use in `tacticalRead<T>()` only — do NOT apply globally,
 * as other API endpoints already use their natural (sometimes snake_case)
 * shapes.
 */

function snakeToCamelKey(key: string): string {
  return key.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());
}

export function keysToCamel<T = unknown>(value: unknown): T {
  if (Array.isArray(value)) {
    return value.map((v) => keysToCamel(v)) as unknown as T;
  }
  if (value !== null && typeof value === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      out[snakeToCamelKey(k)] = keysToCamel(v);
    }
    return out as T;
  }
  return value as T;
}
